import saveData from "../apis/saveData";
import { v4 as uuidv4 } from "uuid";
const descriptors = ["L", "M", "N", "S"];
let recordID = uuidv4();

export const sendAnswer = async (
  surveyKey,
  questionText,
  questionAnswer,
  isFinished,
  timer,
  userId
) => {
  const headers = {
    "Content-Type": `text/plain`,
    Accept: `*/*`,
  };
  try {
    const response = await saveData.post(
      "",
      {
        userId,
        surveyKey,
        recordID,
        questionText,
        questionAnswer,
        questionTime: timer,
        isFinished,
      },
      { headers }
    );

    const flattenResponseData = flatten(response.data);
    recordID = flattenResponseData.recordID;
  } catch (error) {
    console.log(error);
  }
};

function flatten(o) {
  // flattens single property objects that have descriptors
  for (const d of descriptors) {
    if (o.hasOwnProperty(d)) {
      return o[d];
    }
  }

  Object.keys(o).forEach((k) => {
    for (const d of descriptors) {
      if (o[k].hasOwnProperty(d)) {
        o[k] = o[k][d];
      }
    }
    if (Array.isArray(o[k])) {
      o[k] = o[k].map((e) => flatten(e));
    } else if (typeof o[k] === "object") {
      o[k] = flatten(o[k]);
    }
  });

  return o;
}
